import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { RichText } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { Item } from './Item'

export function SustainabilityCertificateInfo() {
  const intl = useIntl()
  const content = intl.formatMessage({ id: 'accommodation_page_sustainability_certificate_content' })
  const hasSustainabilityCertificate = useCMSPageField('PDP.hasSustainabilityCertificate')

  if (!hasSustainabilityCertificate) {
    return null
  }

  return (
    <Item elementDL="sustainably certified" title={intl.formatMessage({ id: 'accommodation_page_sustainability_certificate_title' })} Glyph="Leaf">
      <RichText innerHTML={content} />
    </Item>
  )
}
